export default {"src":"/_next/static/media/welcome-icon.b2309872.svg","height":97,"width":96};